import React from "react";

const sizes = {
  s: "text-[38px] font-semibold md:text-4xl sm:text-[34px]",
  md: "text-5xl font-semibold md:text-[44px] sm:text-[38px]",
  xs: "text-2xl font-semibold md:text-[22px]",
  lg: "text-[54px] font-semibold md:text-[46px] sm:text-[40px]",
};

const Heading = ({ children, className = "", size = "md", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`text-blue_gray-900_01 font-poppins ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
